module.exports = __webpack_public_path__ + "media/reskin-images/icon--x-black-f797bf59.svg";